// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";
// Internal Imports
import { DRAFT } from "../../constants";

// Destructuring
const { TOOLBAR_IDENT_BUTTONS } = DRAFT;

class IdentButtons extends Component {
  _onToggle = (event, type) => {
    event.preventDefault();
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    const { handleIndent } = this.props;
    handleIndent(type);
  };

  onWindowClick = () => {
    this.props.onOverrideContent(undefined);
  };

  render() {
    return TOOLBAR_IDENT_BUTTONS.map(btn => (
      <div className="draft-edit-items" id={btn.toolbarID} key={btn.toolbarID}>
        <div className="draftJsToolbar__buttonWrapper__1Dmqh">
          <Tooltip
            placement="top"
            overlay={btn.tooltip}
            align={{
              offset: [3, 0],
            }}>
            <button
              type="button"
              className={`draftJsToolbar__button__qi1gf align-${
                btn.type
              }-button `}
              onMouseDown={event => this._onToggle(event, btn.type)}
              data-test="identbuttons-btn">
              <i>
                <FontAwesomeIcon icon={["fas", `${btn.icon}`]} />
              </i>
            </button>
          </Tooltip>
        </div>
      </div>
    ));
  }
}

export default IdentButtons;



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/IdentButtons.js